export default __webpack_public_path__ + "locales/es/InfoPanel.json?hash=665cc35ff3b1e6f0ceb516f787bb4c81";